import { api } from '@/lib/api'
import type {
  PredictionFilter,
  PredictionsPage,
  TestRun,
  TestSetDetail,
  TestSetListItem,
  TestSetUploadResponse,
} from '@sophia/shared-schemas'

export const testSetsApi = {
  list: async (): Promise<TestSetListItem[]> => {
    const { data } = await api.get<TestSetListItem[]>('/test-sets')
    return data
  },

  detail: async (id: string): Promise<TestSetDetail> => {
    const { data } = await api.get<TestSetDetail>(`/test-sets/${id}`)
    return data
  },

  upload: async (input: { name: string; file: File }): Promise<TestSetUploadResponse> => {
    const form = new FormData()
    form.append('name', input.name)
    form.append('file', input.file)
    const { data } = await api.post<TestSetUploadResponse>('/test-sets', form)
    return data
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/test-sets/${id}`)
  },

  run: async (id: string): Promise<TestRun> => {
    const { data } = await api.post<TestRun>(`/test-sets/${id}/runs`)
    return data
  },

  predictions: async (
    testSetId: string,
    runId: string,
    params: {
      page: number
      pageSize: number
      filter?: PredictionFilter
      expectedClassId?: string
      predictedClassId?: string
      involvingClassId?: string
    },
  ): Promise<PredictionsPage> => {
    const { data } = await api.get<PredictionsPage>(`/test-sets/${testSetId}/runs/${runId}/predictions`, {
      params,
    })
    return data
  },

  sampleCsvUrl: (): string => {
    // pega o baseURL do axios pra montar a URL com mesma origem
    const base = api.defaults.baseURL ?? ''
    return `${base}/test-sets/sample.csv`
  },
}

export const testSetsQueryKey = {
  all: ['test-sets'] as const,
  list: () => [...testSetsQueryKey.all, 'list'] as const,
  detail: (id: string) => [...testSetsQueryKey.all, 'detail', id] as const,
  predictions: (id: string, runId: string, params: Record<string, unknown>) =>
    [...testSetsQueryKey.all, 'predictions', id, runId, params] as const,
}
